import toggleScroll from '../utils/toggleScroll';

const makePopup = () => {
  $('[data-popup]').on('click', (e) => {
    e.preventDefault();
    const $target = $(e.currentTarget);
    const popupTarget = $target.attr('data-popup');

    if (!popupTarget) {
      return;
    }

    const $popup = $(`.${popupTarget}`);
    const popupTitle = $target.attr('data-popup-title');
    const $popupInputName = $popup.find('.js-input-name');
    const $popupTitle = $popup.find('.js-form-title');
    const dataMetrikaPopup = $target.attr('data-metrika-popup');
    $popup.addClass('popup--active');
    $popup.find('input:first').focus();

    const $parentPopup = $(`.${$target.attr('data-popup-parent')}`);

    if ($parentPopup.length) {
      $parentPopup.removeClass('popup--active');
      return;
    }

    if ($popupInputName.length) {
      $popupInputName.attr('value', '');
    }


    $popupTitle.text($popupTitle.attr('data-text-default'));
    if (popupTitle) {
      $popupInputName.attr('value', popupTitle);
      $popupTitle.text(popupTitle);
    }

    if (dataMetrikaPopup) {
      $popup.find('form').attr('data-metrika-submit', dataMetrikaPopup);
    } else {
      $popup.find('form').attr('data-metrika-submit', '');
    }

    toggleScroll();
  });

  $('.popup').on('click', (e) => {
    const $target = $(e.target);

    if ($target.hasClass('popup__cell') || $target.hasClass('btn-close') || $target.parent().hasClass('btn-close')) {
      $target.closest('.popup').removeClass('popup--active');
      toggleScroll();
    }
  });

  $(document).on('keydown', (e) => {
    if (e.keyCode === 27 && $('.popup--active').length) {
      $('.popup--active').removeClass('popup--active');
      toggleScroll();
    }
  });
};

export default makePopup;
